export enum Bindings {
  ONE_WAY = "<",
  EXPRESSION = "&",
}
